/**
 * CF-DEMO-BALANCE-FLASH-FIX-V1 (PL #7274) — built to Scorer design-align 1208Z.
 *
 * The coinflip surface is a THREE-state machine, not demo-vs-real. Before
 * TonConnect finishes restoring a possible saved wallet, we do NOT yet know if a
 * real wallet exists — so showing the demo experience (fake "100 CREDITS",
 * Practice banner, demo CTA, enabled practice flip) is wrong: a returning
 * real-money player sees a ~1s fake balance flash before their real TON loads.
 *
 *  - 'restoring' — `useIsConnectionRestored()` is false: restore unresolved.
 *    Render NEITHER demo NOR a real-money CTA; only a neutral "Connecting…"
 *    surface. No number, no CREDITS, no Practice banner, no demo CTA, no enabled
 *    flip. (Scorer design-align (b): RESTORING is a third state.)
 *  - 'real' — restore complete AND wallet connected AND positive loaded custodial
 *    balance (hasDeposit). Real-money surface.
 *  - 'demo' — restore complete AND not real (no wallet, or connected-without-
 *    deposit). The genuine practice experience — entered ONLY after restore
 *    proves the wallet state, never as a fallback for unknown/restoring state.
 *
 * Pure + render-free so the three states are unit-testable without a DOM runner
 * (no jsdom yet — CF-FRONTEND-TEST-INFRA-V1). Real-money fail-closed gates
 * (balance freshness, affordability, tier_config) stay at the call site
 * UNCHANGED per Scorer design-align (c) / redscreen-walls R6; this only decides
 * which of the three surfaces renders.
 */
export type CoinflipMode = 'restoring' | 'demo' | 'real';

export function deriveCoinflipMode(
  connectionRestored: boolean,
  isConnected: boolean,
  hasDeposit: boolean,
): CoinflipMode {
  // Restore not yet resolved → never bless unknown wallet state as demo.
  if (!connectionRestored) return 'restoring';
  // Restore complete: real iff a wallet is connected with a positive balance.
  if (isConnected && hasDeposit) return 'real';
  // Restore complete + no real wallet/balance → genuine practice experience.
  return 'demo';
}
